export default __webpack_public_path__ + "static/media/l5-p1.fb5955f8.svg";